import { LabelValueType } from 'scenes/common/types';

export const itemsToValues = (items: string[]): LabelValueType[] =>
  items.map((item) => ({
    label: item,
    value: item,
  }));
